import { prop, propOr } from 'ramda';
import { createSelector } from 'reselect';

import { EMPTY_VALUES } from 'constants/general';

import { REDUCER_NAME } from './slice';

const getRoot = prop([REDUCER_NAME]);

export const getReportModalSuperiors = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'superiors'));
export const getReportModalSubordinates = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'subordinates'));
export const getCheckedWavesIds = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'checkedWavesIds'));
